import React from "react";
import styled from "styled-components";
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter, Redirect } from "react-router-dom";
import { getDealName, fetchDeal } from "store/state/deal";
import { getFundName } from "store/state/fund";
import { getLoanDetailsById, updateLoanDetails, clearUploadErrors } from "store/state/loan/loanDetails";
import { deleteLoanById } from "store/state/loan/loan";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import SimpleInfoDialog from "components/Global/ConfirmationDialogs/SimpleInfoDialog";
import { DEAD, SOLD } from "constants/status";
import loanStatuses from "constants/loanStatuses";
import { ACCESS_TYPE_PORTFOLIO_DEAL, ACCESS_TYPE_PIPELINE_DEAL } from "constants/accessTypes";
import { getGuestsByDealId } from "store/state/guest";
import guestPermissionHelper from "utils/guestPermissionHelper";
import dealById from "selectors/deal";
import LoanDetailsForm from "./LoanDetailsForm";
import LoanDetailsSideNav from "./LoanDetailsSideNav";
import LoanDetailsToolbar from "./LoanDetailsToolbar";

const styles = () => ({
  drawerPaper: {
    position: "relative",
    background: "#f5f5f5",
    zIndex: 300,
    height: "100%"
  }
});

const VerticalSpace = styled.div`
  height: 500px;
`;
const SideNavWrapper = styled.div`
  overflow: auto;
  max-height: calc(100vh - 216px);
`;
const FormWrapper = styled.div`
  position: relative;
  overflow: auto;
  max-height: calc(100vh - 216px);
  margin-left: 16px;
`;

class LoanDetailsPage extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();

    this.state = {
      dealId: "free",
      fundId: "free",
      loanId: "free",
      isEditing: false,
      isCancelModalOpen: false,
      isEditModalOpen: false,
      isDeleteModalOpen: false,
      isLenderValidationModalOpen: false,
      isAmountDrawnValidationModalOpen: false,
      breadcrumbFund: { id: "free", name: null },
      breadcrumbDeal: { id: "free", name: null },
      activeSectionId: "loan_section",
      elementScrollPositions: {},
      addEditAlertIsOpen: false,
      isAlert: true,
      guestPermissions: { isGuest: false },
      loanDetails: props.loanDetails,
      originalLoanDetails: props.loanDetails
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.originalLoanDetails !== props.loanDetails) {
      state.loanDetails = props.loanDetails;
      state.originalLoanDetails = props.loanDetails;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location && nextProps.location && this.props.location.pathname !== nextProps.location.pathname) {
      window.location.reload();
    }
  }

  componentDidMount() {
    this.initialize();
  }

  initialize() {
    const { match } = this.props;
    const fundId = match.params.fundId;
    const dealId = match.params.dealId;
    const loanId = match.params.loanId;
    this.setState({
      dealId,
      fundId,
      loanId,
      isEditing: match.params.isNew === "1" || match.params.isEditing
    });
    this.props.getFundName({ fundId: fundId || "free", subKey: fundId || "free" });
    this.props.getDealName({ dealId, subKey: dealId });
    this.props.getLoanDetailsById({ id: loanId });
    this.props.fetchDeal(dealId);
    const accessTypeId = match.path.indexOf("portfolio") === -1 ? ACCESS_TYPE_PIPELINE_DEAL : ACCESS_TYPE_PORTFOLIO_DEAL;
    this.props.getGuestsByDealId({ dealId, accessTypeId });
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (match.params.loanId !== prevProps.match.params.loanId) {
      this.initialize();
    } else {
      const { loanDetails } = this.state;
      const { loanDetails: prevLoanDetails } = prevProps;

      if (loanDetails.details.id !== prevLoanDetails.details.id) {
        setTimeout(() => {
          this.setState({
            elementScrollPositions: {
              loan_section: this.getOffset("loan_section"),
              loan_section_loan_details: this.getOffset("loan_section_loan_details"),
              loan_section_amort_details: this.getOffset("loan_section_amort_details"),
              loan_section_additional_advances: this.getOffset("loan_section_additional_advances"),
              loan_section_insurance: this.getOffset("loan_section_insurance"),
              loan_section_extension_terms: this.getOffset("loan_section_extension_terms"),
              loan_section_prepayment_terms: this.getOffset("loan_section_prepayment_terms"),
              loan_section_closing_costs: this.getOffset("loan_section_closing_costs"),
              loan_section_contact_info: this.getOffset("loan_section_contact_info"),
              loan_section_property_allocation: this.getOffset("loan_section_property_allocation"),
              covenants_section: this.getOffset("covenants_section"),
              covenants_section_financial_reporting: this.getOffset("covenants_section_financial_reporting"),
              covenants_section_financial_covenants: this.getOffset("covenants_section_financial_covenants"),
              covenants_section_definitions: this.getOffset("covenants_section_definitions"),
              covenants_section_cash_management: this.getOffset("covenants_section_cash_management"),
              covenants_section_escrow_accounts: this.getOffset("covenants_section_escrow_accounts"),
              covenants_section_partial_release: this.getOffset("covenants_section_partial_release"),
              covenants_section_leasing: this.getOffset("covenants_section_leasing"),
              recourse_section: this.getOffset("recourse_section"),
              hedge_requirements_section: this.getOffset("hedge_requirements_section"),
              quote_history_section: this.getOffset("quote_history_section")
            },
            isEditing: loanDetails.details.loanProvider.length === 0 // this is to force an initial edit when the loan/quote does not have a lender associated. This should only happen on a new loan/quote
          });
        });
      }

      const shouldBuildGuestPermissions = guestPermissionHelper.shouldBuildGuestPermissions(
        this.props.authentication.guestAccess,
        this.props.deal,
        this.props.guestPermission,
        this.props.dealguests
      );
      if (shouldBuildGuestPermissions && !this.state.guestPermissions.isGuest) {
        const guestPermissions = guestPermissionHelper.buildGuestPermissions(
          this.props.authentication.guestAccess,
          this.props.deal,
          this.props.guestPermission,
          this.props.dealguests,
          match.path.indexOf("portfolio") === -1 ? "pipelinePermission" : "portfolioPermission",
          this.props.history
        );
        this.setState({ guestPermissions });
      }

      if (this.state.loadExtraction && this.props.extractedLoanDetails) {
        this.props.clearUploadErrors();
        this.setState({ loadExtraction: false, loanDetails: this.props.extractedLoanDetails });
      }
    }
  }

  getOffset = id => {
    const el = document.getElementById(id);
    if (!el) return 0;
    return el.offsetTop - 100;
  };

  calculateAbsDist = (currentScrollTop, elementScrollTop) => {
    const val = currentScrollTop - elementScrollTop;
    if (val < 0) return 999999; // TODO: find a better way to handle negative values than a magic number
    return val;
  };

  findActiveSectionId = scrollTop => {
    const { elementScrollPositions, activeSectionId } = this.state;
    let minDistance = null;
    for (const key in elementScrollPositions) {
      if (elementScrollPositions.hasOwnProperty(key)) {
        const elementDistance = this.calculateAbsDist(scrollTop, elementScrollPositions[key]);
        if (!minDistance) minDistance = { distance: elementDistance, sectionId: key };
        else if (elementDistance < minDistance.distance) minDistance = { distance: elementDistance, sectionId: key };
      }
    }
    if (minDistance == null) return activeSectionId;
    return minDistance.sectionId;
  };

  detectScroll = () => {
    const scrollTop = this.formRef.current.scrollTop;
    const { activeSectionId } = this.state;
    const nextActiveSectionId = this.findActiveSectionId(scrollTop);
    if (nextActiveSectionId && activeSectionId !== nextActiveSectionId) {
      this.setState({
        activeSectionId: nextActiveSectionId
      });
    }
  };

  openEditMode = () => this.setState({ isEditing: true });

  openCancelModal = () => {
    this.setState({ isCancelModalOpen: true });
  };

  closeCancelModal = () => {
    this.setState({ isCancelModalOpen: false });
  };

  openDeleteModal = () => {
    this.setState({ isDeleteModalOpen: true });
  };

  closeDeleteModal = () => {
    this.setState({ isDeleteModalOpen: false });
  };

  openEditModal = () => {
    this.setState({ isEditModalOpen: true });
  };

  closeEditModal = () => {
    this.setState({ isEditModalOpen: false });
  };

  openLenderValidationModal = lenderValidation => {
    this.setState({ isLenderValidationModalOpen: true, lenderValidation });
  };

  openAmountDrawnValidationModal = amountDrawnValidation => {
    this.setState({isAmountDrawnValidationModalOpen: true, amountDrawnValidation});
  }

  closeAmountDrawnValidationModal = () => {
    this.setState({isAmountDrawnValidationModalOpen: false});
  }

  openPropertyValidationModal = (propertyValidation) => {
    this.setState({ isPropertyValidationModalOpen: true, propertyValidation });
  };

  closeLenderValidationModal = () => {
    this.setState({ isLenderValidationModalOpen: false });
  };

  closePropertyValidationModal = () => {
    this.setState({ isPropertyValidationModalOpen: false });
  };

  cancel = () => {
    this.setState({ isEditing: false });
  };

  updateCallback = () => {
    this.setState({ isEditing: false });
  };

  saveAndReturnCallback = () => {
    const { fundId, dealId, loanDetails } = this.state;
    const redirectToPipeline =
      loanDetails.details.loanStatusId &&
      loanDetails.details.loanStatusId !== loanStatuses.CLOSED_LOAN &&
      loanDetails.details.loanStatusId !== loanStatuses.PAID_OFF;

    let path = "";
    if (redirectToPipeline) path = `/pipeline/active/deals/${dealId}`;
    else path = `/portfolio/funds/${fundId}/deals/${dealId}`;

    this.setState({ redirectTo: path });
  };

  assignBreadcrumbNames = (breadcrumbFund, breadcrumbDeal, breadcrumbLoan) => {
    const { dealId, fundId, loanDetails } = this.state;
    const { dealNames, fundNames } = this.props;
    breadcrumbFund.id = fundId;
    breadcrumbDeal.id = dealId;
    breadcrumbFund.name = _.get(fundNames[fundId], "name");
    breadcrumbDeal.name = _.get(dealNames[dealId], "name");
    breadcrumbDeal.dealStatusId = _.get(dealNames[dealId], "dealStatusId");
    breadcrumbLoan.name = _.get(loanDetails, "details.name");
    breadcrumbLoan.lenderName = _.get(loanDetails, ["details", "lenderCompany.name"]);
  };

  selectSection = sectionId => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.parentNode.scrollTo({
        left: 0,
        top: section.offsetTop,
        behavior: "smooth"
      });
    }
  };

  addAlert = () => {
    this.setState({ addEditAlertIsOpen: true, isAlert: true });
  };

  setReminder = () => {
    this.setState({ addEditAlertIsOpen: true, isAlert: false });
  };

  handleCancelAlertReminder = () => {
    this.setState({ addEditAlertIsOpen: false });
  };

  handleSaveAlertReminder = () => {
    this.setState({ addEditAlertIsOpen: false });
  };

  shouldIncludeAlertButtons() {
    const { dealId } = this.state;
    const { dealNames } = this.props;
    const dealStatusId = _.get(dealNames[dealId], "dealStatusId");
    return dealStatusId && dealStatusId !== DEAD && dealStatusId !== SOLD;
  }

  onUploadSpreadsheetModalClose = loadExtraction => {
    this.setState({ loadExtraction });
  };

  deleteLoan = () => {
    const { loanId } = this.state;
    this.props.deleteLoanById({ loanId, callback: this.props.history.goBack });
  };

  render() {
    const {
      loanId,
      isEditing,
      redirectTo,
      isCancelModalOpen,
      isEditModalOpen,
      isDeleteModalOpen,
      isLenderValidationModalOpen,
      breadcrumbFund,
      breadcrumbDeal,
      activeSectionId,
      guestPermissions,
      loanDetails
    } = this.state;
    const breadcrumbLoan = {
      id: loanId,
      loanStatusId: loanDetails.details.loanStatusId,
      isInModification: loanDetails.details.isInModification
    };

    this.assignBreadcrumbNames(breadcrumbFund, breadcrumbDeal, breadcrumbLoan);

    if (redirectTo) return <Redirect to={redirectTo} />;

    const quoteConditions = {
      isQuote:
        loanDetails.details.loanStatusId &&
        loanDetails.details.loanStatusId !== loanStatuses.CLOSED_LOAN &&
        loanDetails.details.loanStatusId !== loanStatuses.MODIFYING &&
        loanDetails.details.loanStatusId !== loanStatuses.PAID_OFF,
      isModifying: loanDetails.details.loanStatusId && loanDetails.details.loanStatusId === loanStatuses.MODIFYING,
      isPassedLoan: loanDetails.details.loanStatusId && loanDetails.details.loanStatusId === loanStatuses.PASSED_QUOTE
    };

    if (quoteConditions.isModifying) {
      quoteConditions.loanTypeName = "Loan";
    } else if (quoteConditions.isQuote) {
      quoteConditions.loanTypeName = "Quote";
    } else {
      quoteConditions.loanTypeName = "closed Loan";
    }

    return (
      <>
        <Grid container alignItems="flex-start" justify="flex-start" direction="row">
          <Grid item xs={12} lg={12}>
            <LoanDetailsToolbar
              fund={breadcrumbFund}
              deal={breadcrumbDeal}
              loan={breadcrumbLoan}
              isEditing={isEditing}
              onOpenEditMode={this.openEditModal}
              onCancel={this.openCancelModal}
              onDelete={this.openDeleteModal}
              onSave={this.save}
              onSaveAndReturn={this.saveAndReturn}
              loanStatusId={loanDetails.details.loanStatusId}
              // Alert / Reminder Props
              includeAlertButtons={this.shouldIncludeAlertButtons()}
              addEditAlertIsOpen={this.state.addEditAlertIsOpen}
              isAlert={this.state.isAlert}
              addAlert={this.addAlert}
              setReminder={this.setReminder}
              handleCancel={this.handleCancelAlertReminder}
              handleSave={this.handleSaveAlertReminder}
              guestPermissions={guestPermissions}
              canDelete
              quoteConditions={quoteConditions}
            />
          </Grid>
          <Grid style={{maxWidth: "210px"}} item sm={2} md={2} lg={2}>
            <SideNavWrapper>
              <LoanDetailsSideNav
                loanId={loanId}
                quoteConditions={quoteConditions}
                isEditing={isEditing}
                activeSectionId={activeSectionId}
                selectSection={this.selectSection}
                onUploadSpreadsheetModalClose={this.onUploadSpreadsheetModalClose}
              />
            </SideNavWrapper>
          </Grid>
          <Grid item sm={10} md={10} lg={10}>
            <FormWrapper style={{paddingLeft: "100px", width: "100%"}} ref={this.formRef} onScroll={this.detectScroll}>
              <LoanDetailsForm
                id={loanId}
                isEditing={isEditing}
                loan={loanDetails}
                updateCallback={this.updateCallback}
                openLenderValidationModal={this.openLenderValidationModal}
                openAmountDrawnValidationModal = {this.openAmountDrawnValidationModal}
                openPropertyValidationModal={this.openPropertyValidationModal}
                saveAndReturnCallback={this.saveAndReturnCallback}
                setRevert={revert => (this.revertForm = revert)}
                setSave={save => (this.save = save)}
                setSaveAndReturn={saveAndReturn => (this.saveAndReturn = saveAndReturn)}
                quoteConditions={quoteConditions}
                guestPermissions={guestPermissions}
                deal={this.props.deal}
                match = {this.props.match}
              />
              <VerticalSpace />
            </FormWrapper>
          </Grid>
        </Grid>

        <SimpleConfirmDialog
          title="Confirm Cancel"
          message="You are about to cancel all of your changes. Are you sure you want to do this?"
          noText="NO"
          yesText="YES, CANCEL"
          modalOpen={isCancelModalOpen}
          handleNo={this.closeCancelModal}
          handleYes={() => {
            this.revertForm();
            this.setState({ isCancelModalOpen: false, isEditing: false });
          }}
        />

        <SimpleConfirmDialog
          title="Confirm Delete"
          message={`You are about to delete this ${quoteConditions.loanTypeName}. This cannot be undone. Are you sure you want to do this?`}
          noText="NO"
          yesText="YES, DELETE"
          modalOpen={isDeleteModalOpen}
          handleNo={this.closeDeleteModal}
          handleYes={() => {
            this.deleteLoan();
            this.setState({ isDeleteModalOpen: false, isEditing: false });
          }}
        />

        <SimpleConfirmDialog
          title="Confirm Edit"
          message={`You are about to edit a ${quoteConditions.loanTypeName}. Are you sure you want to do this?`}
          noText="NO"
          yesText="YES, EDIT"
          modalOpen={isEditModalOpen}
          handleNo={this.closeEditModal}
          handleYes={() => {
            this.openEditMode();
            this.setState({ isEditModalOpen: false, isEditing: true });
          }}
        />
        {this.state.lenderValidation && (
          <SimpleInfoDialog
            title="Lender Error"
            message="One of the following errors was encountered when attempting to save the lender information"
            secondaryContent="Please fix these issues in order to save successfully."
            bulletPoints={[
              !this.state.lenderValidation.details.allocationSumCheck ? "Lender Allocations do not add up to equal the Loan Amount" : null,
              !this.state.lenderValidation.details.leadCheck ? "No Lead Lender was selected" : null,
              !this.state.lenderValidation.details.nonNullCheck ? "Lender Information not fully filled out" : null
            ]}
            modalOpen={isLenderValidationModalOpen}
            handleClose={this.closeLenderValidationModal}
            handleAccept={this.closeLenderValidationModal}
          />
        )}
        {this.state.isPropertyValidationModalOpen && (
          <SimpleInfoDialog
            title="Property Allocation Error"
            message="One of the following errors was encountered when attempting to save the property allocation information"
            secondaryContent="Please fix these issues in order to save successfully."
            bulletPoints={[
              !this.state.propertyValidation.details.allocationSumCheck ? "Property allocations do not add up to 100%" : null,
              !this.state.propertyValidation.details.uniquePropertyCheck ? "A property was listed more than once" : null
            ]}
            modalOpen
            handleClose={this.closePropertyValidationModal}
            handleAccept={this.closePropertyValidationModal}
          />
        )}
        {this.state.amountDrawnValidation && (
          <SimpleInfoDialog
            title="Escrow Accounts Error"
            message="One of the following errors was encountered when attempting to save the escrow information"
            secondaryContent="Please fix these issues in order to save successfully."
            bulletPoints={[
              !this.state.amountDrawnValidation.details.goodNewsCheck ? "Good News amount drawn exceeds reserves" : null,
              !this.state.amountDrawnValidation.details.capExCheck ? "Cap Ex amount drawn exceeds reserves" : null,
            ]}
            modalOpen={this.state.isAmountDrawnValidationModalOpen}
            handleClose={this.closeAmountDrawnValidationModal}
            handleAccept={this.closeAmountDrawnValidationModal}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { dealId }
    }
  }
) => {
  const { authentication, deal, fund, loanDetails, guest } = state;
  return {
    authentication,
    deal: dealById(state, dealId),
    dealStore: deal,
    dealNames: deal.dealNames,
    fundNames: fund.fundNames,
    loanDetails: loanDetails.loanDetails,
    dealguests: guest.dealguests ? guest.dealguests[dealId] : [],
    guestPermission: guest.guestPermission ? guest.guestPermission : null,
    extractedLoanDetails: loanDetails.extractedLoanDetails
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getDealName,
    getLoanDetailsById,
    updateLoanDetails,
    getFundName,
    fetchDeal,
    getGuestsByDealId,
    clearUploadErrors,
    deleteLoanById
  }),
  withStyles(styles)
)(LoanDetailsPage);
